import { useState, useEffect, useCallback } from "react";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { Button, Card, Col, Modal, ModalHeader, ModalBody, ModalFooter, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routers/routes";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { Configuration, usersTitle } from "../../../constants";
import Table from "../../table/Table";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";
import LoadingComponent from "../../lodingComponent";
import { Filter } from "react-feather";

const Users = () => {



    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    const [selectedUserId, setSelectedUserId] = useState("");
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const role = useAppSelector((state) => state.role.role);

    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy,
        loading
    } = usePagination({
        endpoint: `/auth/users`,
        filterOn: 'UserName',
        enabled:true
    })
    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])
    /* const getUsers = async () => {
         try{
         const response = await ApiService.axiosApi('/auth/users',{
             method: 'GET',
         })
 
           if(response.success){
             const data = response.data; 
             setUsers(data);
             console.log(data);
           }
           else {
             console.log(response.data.message); 
             toast.error(response.data.message);
           }
         } catch (error: any) {
             toast.error(error.message);
         }
     }
     useEffect(() => {
         
         getUsers();
     }, [refresh]);*/

    // delete user
    const handleDelete = (Id: string) => {
        setSelectedUserId(Id);
        setIsDeleteModalOpen(true);
    }

    const handleDeleteUser = async (selectedUserId: string) => {
        try {
            console.log(selectedUserId);
            const response = await ApiService.axiosApi(`/auth/${selectedUserId}`, {
                method: 'DELETE',
            });

            if (response.success) {
                
                toast.success(response.data.UserName);
                setIsDeleteModalOpen(false);
                setRefresh(prev => !prev);
            }
            else {
                toast.error(response.message);
            }
        } catch (error: any) {
            toast.error(error.message);
        }
    }

    
    //handledetail

    const handleDetailButton = (Id: string) => {

        navigate(`/user-profile-page/${Id}`)
    }


    return (
        <>
            <Breadcrumbs mainTitle={usersTitle} parent={Configuration} />
            
                <Card>
                    <CommonCardHeader title="UserList" headClass={"pb-3"} />
                    <div className="d-flex justify-content-between">
                    <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                        <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                        </div>
                           <div>
                           <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('UserName')}>
                         <Filter/>
                       </button>
                           </div>
                        
                    </div>
                        {role === "Administrator" && (
                            <div className="d-flex justify-content-end">
                                <Button onClick={() => navigate('/user-register')} color="primary" className="mb-2 mx-2">Add User</Button>
                            </div>
                        )}
                    </div>
                    {loading?<LoadingComponent/>:<Table
                        data={data}
                        columns={[
                            { header: "Phone Number", accessor: "phoneNumber" },
                            { header: "Name", accessor: "userName" },
                            { header: "Email", accessor: "email" },
                            { header: "Access Level", accessor: "role" },
                        ]}

                        buttons={[
                            { label: "Details", onClick: handleDetailButton, color: "primary", className: "me-2" },

                        ]}
                    />}
                    

                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>
                </Card>


                <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>

                    <ModalHeader>Delete User</ModalHeader>
                    <ModalBody>Are you sure you want to delete this user?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => handleDeleteUser(selectedUserId)}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>

                </Modal>

            
        </>
    )
}


export default Users;
